module.exports = __webpack_public_path__ + "static/media/home.579e7575.svg";